export default __webpack_public_path__ + "static/media/img3.c2931cfb.jpg";